<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import qs from 'query-string';

    import Box from '../_wrappers/Box.svelte';
    import Block from '../Block.svelte';

    import type { Box as BoxType, Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let box: BoxType;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';

    const columnCount = childComponents.length;

    const isSingleColumn = columnCount === 1;
    const isInMultiColumn = columnCount > 1;

    const boxWithOptimizedBgImage = { ...box };

    const boxBgImageSrc = boxWithOptimizedBgImage.bgImage?.src;

    if (boxWithOptimizedBgImage.bgImage && boxBgImageSrc) {
        // Get screen width for crisp BG image
        const screenWidth = window?.innerWidth || 1440;
        const defaultImgixParams = {
            auto: 'format,compress',
            w: screenWidth,
            dpr: 2,
            q: 80,
        };

        const rawSrc = boxBgImageSrc?.split('?')[0];
        const existingParams = boxBgImageSrc?.split('?')[1];
        const updatedParams = existingParams
            ? {
                  ...qs.parse(existingParams),
                  ...defaultImgixParams,
              }
            : defaultImgixParams;

        const optimizedSrc = `${rawSrc}?${qs.stringify(updatedParams)}`; // do something with boxBgImage

        boxWithOptimizedBgImage.bgImage.src = optimizedSrc;
    }
</script>

<Box {...boxWithOptimizedBgImage} {transitionDelay} {transitionEffect} desktop>
    <div
        {id}
        class={cn('fun-grid fun-grid-cols-1 fun-gap-4 fun-px-4 lg:fun-px-12', {
            'md:fun-grid-cols-2': !isSingleColumn,
            'lg:fun-grid-cols-3': columnCount === 3,
            'xl:fun-grid-cols-4': columnCount >= 4,
        })}
    >
        <!-- GridColumns -->
        {#each childComponents as component, index}
            <Block
                id={component._id}
                componentType={component.componentType}
                childComponents={component.components}
                content={component.content}
                layout={{
                    isInColumn: false,
                    isInSingleColumn: isSingleColumn,
                    isInFramedColumn: false,
                    isInMultiColumn,
                    columnCount,
                    isInList: false,
                }}
                {language}
                {campaignId}
                {campaignVersionId}
                {companyId}
                {cookiesEnabled}
                {theme}
                {nextPage}
                {currentPage}
                {resultMapping}
                {fields}
                {firstResultPage}
                {trackingProperties}
                {index}
            />
        {/each}
    </div>
</Box>
